<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <span
          style="color:red;font-size: 16px;font-weight: bold;margin-left: 20px">注：宣传品，礼品，干冰邮寄:销售助理负责；保护剂邮寄:实验室龙欢负责</span>
      </div>
      <export-components :apiFunction="downloadRequest" :requestData="requestData" :option="option" @sendData=getSearchData>
      </export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      :table-col-check="{isShow:true,name:'Request1' + activeTab}" :key="activeTab" ref="wMyTable"
      :page="page" @pageChange="handlePagePagination($event)" :isShowRowSelection="true">
      <div slot="operation" slot-scope="{record}">
        <el-button size="mini" type="primary"
          v-if="record.status === 'DEFEAT' && record.materialType!=='PROTECT_REAGENT'"
          @click="handleEdit(record)">重新申请</el-button>
        <!--              <el-button size="mini" type="success" @click="handleDetails(record)">详情</el-button>-->
      </div>
      <div slot="recipient" slot-scope="{record}">
        <span v-if="record.recipientName">{{record.recipientName + ',' + record.recipientPhone + ',' +
          record.recipientAddress}}</span>
      </div>
      <div slot="Flag" slot-scope="{record}">
        <div v-if="record['status'] ==='DEFEAT'">
          <span v-if="record['status'] === 'DEFEAT'" style="display: flex;align-items: center">
            <el-tag type="primary">
              <span>已取消</span>
            </el-tag>
            <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look" :text="record.rejectionReason"
              :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
            </w-ellipsis-and-look>
          </span>
        </div>
        <div v-else-if="record['materialType']!=='DRY_ICE' && record['status'] !=='DEFEAT'">
          <el-tag v-if="record['trackingFlag'] === 1" type="success">已邮寄</el-tag>
          <el-tag v-else-if="record['trackingFlag'] === 0" type="warning">待邮寄</el-tag>
          <el-tag v-else type="info">未知状态</el-tag>
        </div>
        <div v-else-if="record['materialType']==='DRY_ICE' && record['status'] !=='DEFEAT'">
          <el-tag v-if="record['arrangeFlag'] === 1" type="success">已安排</el-tag>
          <el-tag v-else-if="record['arrangeFlag'] === 0" type="warning">待安排</el-tag>
          <el-tag v-else type="info">未知状态</el-tag>
        </div>
      </div>
      <div slot="material" slot-scope="{record,index}"
        v-if="record.materialRequestDetailDTOS && record.materialRequestDetailDTOS.length>0">
        <ex-fold-cell-too :data="materialData" :index="index" :record="record.materialRequestDetailDTOS"
          :unit="record.materialType === 'PROTECT_REAGENT'?'specs':null"></ex-fold-cell-too>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <add-edit-request v-if="showAddEditDialog" :show-dialog="showAddEditDialog" :select-type="selectType"
      :select-detail="selectDetail" @submit="closeAddEditDialog"></add-edit-request>
    <request-details v-if="showRequestDetail" :show-dialog="showRequestDetail" :select-detail="RequestDetail"
      @submit="closeShowRequest"></request-details>
  </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import {downloadRequest, getRequestPage} from "@/api/dilivery/material/request";
import {request} from "@/utils/data/tableCol/material/request/request";
import AddEditRequest from "@/components/material/Request/AddEditRequest.vue";
import RequestDetails from "@/components/material/Request/RequestDetails.vue";
import ExFoldCellToo from "@/components/ExFoldCellToo.vue";
import TableCol from "@/components/customerTable/TableCol.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ExportComponents from "@/components/ExportComponents.vue";
import _ from "lodash";

export default {
  name: "Request",
  components: { ExportComponents, PictureLoading, TableCol, ExFoldCellToo, RequestDetails, AddEditRequest, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      materialData: {name: 'materialLexiconDTO.materialName', value: 'number'},
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '待邮寄/待安排', name: 'will', showBadge: true },
        { label: '已邮寄/已安排', name: 'mailed', showBadge: false },
        { label: '已取消', name: 'not', showBadge: false },
      ],
      sendData: {
        all: {},
        will: { "query#status.EQ": "SUCCESS", "mailedOrArrangedFlag": false },
        mailed: { "query#status.EQ": "SUCCESS", "mailedOrArrangedFlag": true },
        not: { "query#status.EQ": "DEFEAT" },
      },
      pageTotal: { all: 0, will: 0, mailed: 0, not: 0 },
      checkedCol: [],
      activeTab: 'all',
      loading: true,
      showAddEditDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      showRequestDetail: false,
      RequestDetail: '',
      selectType: '',
      option: [
        {label: '送达时间(干冰)', value: 'deliveryTime'},
        {label: '处理时间', value: 'operatingTime'},
        {label: '创建时间', value: 'createTime'},
      ]
    }
  },
  computed: {
    columns() {
      let cols = request([] || {});
      if (['mailed', 'will'].includes(this.activeTab)) {
        cols.shift()
      }
      if (['will'].includes(this.activeTab)) {
        cols = cols.filter(item => !['operator', 'operatingTime', 'trackingNumber'].includes(item.key))
      }
      return JSON.parse(JSON.stringify(cols))
    },
    requestData() {
      let data = { ...this.sendData[this.activeTab] }
      data = this.getSearch(data)
      return data
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    downloadRequest,
    loadAllTabTotals() {
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getRequestPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    //已提交表格选择框
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    // 获取邮寄表数据
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      };
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] };
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getRequestPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.currentNum = parseInt(res.data.current);
          this.page.pageSize = parseInt(res.data.size);
          this.page.total = parseInt(res.data.total);
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      });
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    getSearch(sendData) {
      
      const keys = ['salesName']
      this.searchConditionTag.forEach(item => {
        if (['deliveryTime', 'operatingTime', 'createTime'].includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else if (keys.includes(item.key)) {
          sendData[item.key] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    //编辑表格显示列
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = 'edit'
      } else {
        this.selectType = 'add'
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    handleDetails(row) {
      this.RequestDetail = row
      this.showRequestDetail = true
    },
    closeShowRequest() {
      this.$nextTick(() => {
        this.showRequestDetail = false
      })
    },
    // 关闭编辑、增加弹出框
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.$store.commit('right/setChangeRed', true)
        this.getData()
      }
      this.$nextTick(() => {})
      this.showAddEditDialog = false
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
</style>
